import { gql } from "@apollo/client";

export const GET_SOS = (
    page?: number,
    pageSize?: number,
    orderBy: "asc" | "desc" = "desc",
) => {
    // Paginación
    // Si no se pasa pageSize o page, no se aplica paginación
    const paginationArgs = pageSize && page
        ? `, limit: ${pageSize}, offset: ${(page ? (page - 1): 0) * pageSize}`
        : "";

    // Filtros para condición where
    const filters: string[] = [];


    // Si hay filtros, se agrega la cláusula where
    const whereClause = filters.length > 0 ? `, where: { ${filters.join(", ")} }` : "";

    return gql`
        query MyQuery {
            its_sos_aggregate(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
            ) {
                aggregate {
                count
                }
            }
            its_sos(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
                ${paginationArgs}
            ) {
                id
                description
                user_extension
                created_at
                updated_at
            }
        }
    `;
}